import React from 'react'
import { injectIntl, Link } from 'gatsby-plugin-intl'

import './next.scss'

const CaseNext = ( { className, caseDomain, intl } ) => {
  return (
    <div className={ "block text next " + className }>
      <Link className="description" to={ "/cases/" + caseDomain } >
        <h1 className="title">
          { intl.formatMessage( { id: `cases.${ caseDomain }.title` } ) }
        </h1>
        <div className="objectives">
          { intl.formatMessage( { id: `cases.${ caseDomain }.objectives` } ) }
         <div className="areas">
          { intl.formatMessage( { id: `cases.${ caseDomain }.areas` } ) }
        </div>
        </div>
      </Link>
    </div>
  )
}

const injected = injectIntl( CaseNext )
export { injected as CaseNext }
